import React, { Component } from 'react';

//React-PDF dependencies
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";

//React-PDF custom components
import PdfIcon from './PdfIcon';
import AsyncPdfImage from './AsyncPdfImage';

Font.register({ family: 'Roboto', format: 'truetype', src: '//fonts.gstatic.com/s/roboto/v16/zN7GBFwfMP4uA6AR0HCoLQ.ttf' });

const styles = StyleSheet.create({
  image: {
    transform: 'rotate(90deg)',
    marginRight: 5,
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  card: {
    display: "flex",
    flexDirection: "column",
    margin: '8 0',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: "#d9d9d9",
    width: "100%",
    title: {
      margin: 2,
      fontSize: 13,
      fontWeight: 900,
      fontFamily: 'Roboto',
    },
    primaryIcon: {
      alignItems: 'center',
      justifyContent: 'center',
      width: 30,
      height: 30,
      margin: 7,
      backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
      borderRadius: 40,
      icon:{
        width: 18,
      },
    },
    secondaryIcon: {
      margin: '5 10',
      alignItems: 'center',
      justifyContent: 'center',
      width: 25,
      height: 25,
      backgroundColor: "#ec407a",
      borderRadius: 40,
      icon:{
        width: 14,
      },
    },
    column: {
      display: 'flex',
      flexDirection: 'row',
    },
    row: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    subHeader: {
      marginTop: 2,
      background: '#000000',
      opacity: 0.5,
      fontSize: 10,
      fontFamily: 'Roboto',
    },
    text: {
      left: 10,
      fontSize: 12,
      fontFamily: 'Roboto',
    },
  },
});

class ProjectLogEntryPDF extends Component {

  render() {

    const { data } = this.props;
    let event = new Date(Date.parse(this.props.ple.date))

    return (
      <View style={styles.card} wrap={false}>
        <View style={styles.card.column}>
          <PdfIcon
            src="https://img.icons8.com/ios-filled/100/FFFFFF/chat-message.png"
            style={styles.card.primaryIcon}
          />
          <View style={styles.card.row}>
            <Text style={styles.card.title}>
              {this.props.ple.device.user.fullName}
            </Text>
            <Text style={styles.card.subHeader}>
              {event.toDateString() +" at "+event.getHours()+":"+event.getMinutes()+":"+event.getSeconds()}
            </Text>
          </View>
        </View>
        <View>
          <Text style={styles.card.text}>
            {this.props.ple.comment}
          </Text>
        </View>
        {this.props.ple.images.map((tile, id) => (
          <View key={id} style={styles.image.container}>
            <AsyncPdfImage key={id} projectId={tile.project.id} imageId={tile.id} size="1000x1000" data={data}/>
          </View>
        ))}
      </View>
    );
  }
}
export default ProjectLogEntryPDF;


// WEBPACK FOOTER //
// src/components/innerComponents/pdfComponents/ProjectLogEntryPdf.js